import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ScrollToTop from "../component/ScrollToTop";
export default function BlockchainConsulting() {
  return (
    <>
      <ScrollToTop>
        <Header />
        <section className="hero_padding blockchainconsulting_bg">
          <div className="container">
            <div className="row my-md-5 my-3">
              <div className="col-lg-5">
                <h1 className="heading-1">Technology consulting</h1>
                <p className="font_14 body-regular">
                  Build your strongest foundation in crypto
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding pb-0">
          <div className="container">
            <div className="row align-items-center g-lg-5 g-4">
              <div className="col-lg-6 order-2 order-lg-1">
                <h2 className="heading-2 fw-bold mb-xl-5 mb-3">
                  Blockchain Consulting
                </h2>
                <p className="sub_para">
                  As businesses adjust to a new and unusual sense of normal,
                  having ecosystem-level collaboration and optimization is
                  essential for sustaining continual growth.
                </p>
                <p className="sub_para">
                  Our blockchain consulting services makes this possible by
                  building a scalable, enterprise-grade distributed system for
                  your purposes, using a proven network design framework that
                  drives operational agility while opening new revenue streams.
                </p>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <img
                  src="assets/img/TechnologyConsulting/right_sec.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding">
          <div className="container">
            <div className="Engineered_sec">
              <div className="row text-white gx-md-5 gy-md-0">
                <h2 className="heading-2 mb-md-5 mb-3">
                  Engineered for your success
                </h2>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">
                      Blockchain Workshop
                    </h6>
                    <p className="sub_para para_color">
                      Identify industry opportunities and considerations
                      relevant to your business.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">Enterprise</h6>
                    <p className="sub_para para_color">
                      Get the knowledge and technical skills to implement
                      enterprise blockchain solutions into your organisation.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">
                      Blockchain Security
                    </h6>
                    <p className="sub_para para_color">
                      We employ cutting-edge cybersecurity protocols and
                      solutions to keep your business safe and secure.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">
                      Proof of concept
                    </h6>
                    <p className="sub_para para_color">
                      We develop a Proof of Concept to ensure your blockchain
                      solution will work in the real world.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">Tokenisation</h6>
                    <p className="sub_para para_color">
                      From real estate through to stocks, assets can be
                      fractionalised and shared between many owners.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">
                      Strategy assessment
                    </h6>
                    <p className="sub_para para_color">
                      assess your goals and evaluate applicability and business
                      impact to define and prioritiSe transformation.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">
                      Governance design
                    </h6>
                    <p className="sub_para para_color">
                      Design an operational model for the members of your
                      business network.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">
                      Solution design
                    </h6>
                    <p className="sub_para para_color">
                      solution design of people, process, operating model and
                      technology to maximise your transformation.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card_to_border">
                    <h6 className="sub_heading text_blue mb-lg-3 mb-2">
                      Ecosystem management
                    </h6>
                    <p className="sub_para para_color">
                      handle the operation of your new blockchain networks and
                      ecosystems using our proven functional expertise.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section_padding pt-0">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-xl-8">
                <h2 class="heading-2 text-center">
                  Ingredients for your build
                </h2>
                <p class="sub_para text-center mb-xl-5 mb-md-4 mb-3">
                  Having projects delivered around the world, our clients have
                  taught us that truly great engineering consists of multiple,
                  interconnected elements.
                </p>
                <div class="row overflow-auto my-xl-4 my-3">
                  <div class="d-flex justify-content-center">
                    <ul
                      class="nav nav-pills d-flex flex-nowrap overflow-auto gap-md-4 gap-2"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link active font_14 fw-semibold text-nowrap tech_pill"
                          id="frontend-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#frontend"
                          type="button"
                          role="tab"
                          aria-controls="frontend"
                          aria-selected="true"
                        >
                          Frontend
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link  font_14 fw-semibold text-nowrap tech_pill"
                          id="backend-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#backend"
                          type="button"
                          role="tab"
                          aria-controls="backend"
                          aria-selected="false"
                        >
                          Backend
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link font_14 fw-semibold text-nowrap tech_pill"
                          id="blockchain-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#blockchain"
                          type="button"
                          role="tab"
                          aria-controls="blockchain"
                          aria-selected="false"
                        >
                          Blockchain
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link  font_14 fw-semibold text-nowrap tech_pill"
                          id="mobile-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#mobile"
                          type="button"
                          role="tab"
                          aria-controls="mobile"
                          aria-selected="false"
                        >
                          Mobile
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link  font_14 fw-semibold text-nowrap tech_pill"
                          id="infra-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#infra"
                          type="button"
                          role="tab"
                          aria-controls="infra"
                          aria-selected="false"
                        >
                          Infra & DevOps
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link  font_14 fw-semibold text-nowrap tech_pill"
                          id="uiux-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#uiux"
                          type="button"
                          role="tab"
                          aria-controls="uiux"
                          aria-selected="false"
                        >
                          UI/UX
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="tech_border p-2">
              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="frontend"
                  role="tabpanel"
                  aria-labelledby="frontend-tab"
                >
                  <div className="row justify-content-center text-center py-lg-2 pb-0">
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/reactjs.svg"
                        alt="ReactJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">ReactJS</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/angulerjs.svg"
                        alt="Angular"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Angular</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/typescript.svg"
                        alt="TypeScript"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">TypeScript</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/jquery.svg"
                        alt="jQuery"
                        className="img-fluid "
                      />
                      <p className="font_14 mb-0">jQuery</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/vuejs.svg"
                        alt="VueJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">VueJS</p>
                    </div>
                  </div>
                  <div className="row justify-content-center text-center">
                    <div className="col-lg-2  my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/nextjs.svg"
                        alt="NextJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">NextJS</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/csharp.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">C#</p>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="backend"
                  role="tabpanel"
                  aria-labelledby="backend-tab"
                >
                  <div className="row justify-content-center text-center py-lg-2 pb-0">
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/nodejs.svg"
                        alt="ReactJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">NodeJS</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/expressjs.svg"
                        alt="Angular"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">ExpressJS</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/javascript.svg"
                        alt="TypeScript"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">JavaScript</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/rust.svg"
                        alt="jQuery"
                        className="img-fluid "
                      />
                      <p className="font_14 mb-0">Rust</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/python.svg"
                        alt="VueJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Python</p>
                    </div>
                  </div>
                  <div className="row justify-content-center text-center">
                    <div className="col-lg-2  my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/php.svg"
                        alt="NextJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">PHP</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/codeIgniter.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">CodeIgniter</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/nestjs.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">NestJS</p>
                    </div>
                  </div>
                </div>

                {/* --------------blockchain-------- */}
                <div
                  class="tab-pane fade"
                  id="blockchain"
                  role="tabpanel"
                  aria-labelledby="blockchain-tab"
                >
                  <div className="row justify-content-center text-center py-lg-2 pb-0">
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Ethereum.svg"
                        alt="ReactJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Ethereum</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Solana.svg"
                        alt="Angular"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Solana</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Algorand.svg"
                        alt="TypeScript"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Algorand</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/BSC.svg"
                        alt="jQuery"
                        className="img-fluid "
                      />
                      <p className="font_14 mb-0">BSC</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/ConsenSys.svg"
                        alt="VueJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">ConsenSys</p>
                    </div>
                  </div>
                  <div className="row justify-content-center text-center">
                    <div className="col-lg-2  my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Tron.svg"
                        alt="NextJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Tron</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/OpenZeppelin.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">OpenZeppelin</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/HyperLedger.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">HyperLedger</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/PyTeal.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">PyTeal</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/R3Corda.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">R3 Corda</p>
                    </div>
                  </div>
                </div>
                {/* -------mobile------ */}
                <div
                  class="tab-pane fade"
                  id="mobile"
                  role="tabpanel"
                  aria-labelledby="mobile-tab"
                >
                  <div className="row justify-content-center text-center py-lg-2 pb-0">
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/reactjs.svg"
                        alt="ReactJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">React Native</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Swift.svg"
                        alt="Angular"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Swift</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/ObjectiveC.svg"
                        alt="TypeScript"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Objective C</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Xamarin.svg"
                        alt="jQuery"
                        className="img-fluid "
                      />
                      <p className="font_14 mb-0">Xamarin</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Flutter.svg"
                        alt="VueJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Flutter</p>
                    </div>
                  </div>
                  <div className="row justify-content-center text-center">
                    <div className="col-lg-2  my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/iOS.svg"
                        alt="NextJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">iOS</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Android.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Android</p>
                    </div>
                  </div>
                </div>

                {/* ----infra---- */}
                <div
                  class="tab-pane fade"
                  id="infra"
                  role="tabpanel"
                  aria-labelledby="infra-tab"
                >
                  <div className="row justify-content-center text-center py-lg-2 pb-0">
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/GitHubActions.svg"
                        alt="ReactJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">GitHub Actions</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Cloudformation.svg"
                        alt="Angular"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Cloudformation</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Docker.svg"
                        alt="TypeScript"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Docker</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Terraform.svg"
                        alt="jQuery"
                        className="img-fluid "
                      />
                      <p className="font_14 mb-0">Terraform</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Ansible.svg"
                        alt="VueJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Ansible</p>
                    </div>
                  </div>
                  <div className="row justify-content-center text-center">
                    <div className="col-lg-2  my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Jenkins.svg"
                        alt="NextJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Jenkins</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Fireblocks.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Fireblocks</p>
                    </div>
                  </div>
                </div>

                {/* ---ui/ux---- */}
                <div
                  class="tab-pane fade"
                  id="uiux"
                  role="tabpanel"
                  aria-labelledby="uiux-tab"
                >
                  <div className="row justify-content-center text-center py-lg-2 pb-0">
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Figma.svg"
                        alt="ReactJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Figma</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/SketchApp.svg"
                        alt="Angular"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Sketch App</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/XD.svg"
                        alt="TypeScript"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">XD</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/MIRO.svg"
                        alt="jQuery"
                        className="img-fluid "
                      />
                      <p className="font_14 mb-0">MIRO</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Illustrator.svg"
                        alt="VueJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Illustrator</p>
                    </div>
                  </div>
                  <div className="row justify-content-center text-center">
                    <div className="col-lg-2  my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Photoshop.svg"
                        alt="NextJS"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Photoshop</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Dovetail.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Dovetail</p>
                    </div>
                    <div className="col-lg-2 my-2 d-flex align-items-center">
                      <img
                        src="assets/img/639b830a4cbdd20fd5f3a9a9/Balsamiq.svg"
                        alt="C#"
                        className="img-fluid"
                      />
                      <p className="font_14 mb-0">Balsamiq</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section_padding bg_dark">
          <div className="container">
            <div className="row text-white align-items-center g-lg-5 g-4">
              <div className="col-lg-6 order-2 order-lg-1">
                <h2 className="heading-2 mb-xl-5 mb-3">Decentralised Future</h2>
                <p className="sub_para mb-4">
                  Helping a wide variety of organisations embrace—and
                  harness—the power of blockchain, we have served governments as
                  well as industries including aerospace, financial services,
                  energy, transportation and logistics, and food and beverage.
                </p>
                <ul className="sub_para">
                  <li>Smart Contracts</li>
                  <li>NFT Marketplaces</li>
                  <li>Blockchain Advisory</li>
                  <li>DeFi Solutions</li>
                  <li>Digital Assets trading</li>
                  <li>Digital Wallet</li>
                </ul>
                <button
                  type="button"
                  className="btn text-white grey_button mt-xl-4 mt-3"
                >
                  Contact
                </button>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="d-flex justify-content-center">
                  <img
                    src="assets/img/TechnologyConsulting/Decentralised.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding pb-0">
          <div className="container">
            <div className="mb-lg-5 mb-4">
              <h2 className="heading-2">Engineering Methodology</h2>
              <p className="sub_para">
                Whether starting with a blank slate or optimising a mature
                product at scale, our methodology works for every stage of your
                product creation journey.
              </p>
            </div>
            <div className="grid-container">
              <div className="card_bg_green">
                <img
                  src="assets/img/TechnologyConsulting/img1.svg"
                  alt=""
                  className="mb-xl-5 mb-md-4 mb-3"
                />
                <p className="heading-4 mb-0 fw-bold">Initial consult</p>
              </div>
              <div className="card_bg_green">
                <img
                  src="assets/img/TechnologyConsulting/img-2.svg"
                  alt=""
                  className="mb-xl-5 mb-md-4 mb-3"
                />
                <p className="heading-4 mb-0 fw-bold">Technical scoping</p>
              </div>
              <div className="card_bg_green">
                <img
                  src="assets/img/TechnologyConsulting/img3.svg"
                  alt=""
                  className="mb-xl-5 mb-md-4 mb-3"
                />
                <p className="heading-4 mb-0 fw-bold">Backlog creation</p>
              </div>
              <div className="card_bg_green">
                <img
                  src="assets/img/TechnologyConsulting/img-4.svg"
                  alt=""
                  className="mb-xl-5 mb-md-4 mb-3"
                />
                <p className="heading-4 mb-0 fw-bold">Systems Integration</p>
              </div>
              <div className="card_bg_green">
                <img
                  src="assets/img/TechnologyConsulting/img5.svg"
                  alt=""
                  className="mb-xl-5 mb-md-4 mb-3"
                />
                <p className="heading-4 mb-0 fw-bold">Lift off</p>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding">
          <div className="container">
            <div className="row g-xl-5 g-4">
              <h2 className="heading-2 mb-xl-5 mb-3">
                Deploy globally, at scale.
              </h2>
              <div className="col-md-6">
                <div className="d-flex gap-4 align-items-start">
                  <img
                    src="assets/img/TechnologyConsulting/Deploy_img1.svg"
                    alt=""
                  />
                  <div>
                    <h6 className="heading-4 mb-3 fw-bold">
                      Deep technical expertise
                    </h6>
                    <p className="sub_para para_color ">
                      Our industry agnostic approach towards solving technical
                      objectives span over 25 years of in house expertise,
                      allowing you to leapfrog with our research and developmeng
                      for faster delivery.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-4 align-items-start">
                  <img
                    src="assets/img/TechnologyConsulting/Deploy_img2.svg"
                    alt=""
                  />
                  <div>
                    <h6 className="heading-4 mb-3 fw-bold">
                      Hyper focued on your growth
                    </h6>
                    <p className="sub_para para_color ">
                      We are a team comprised of diverse backgrounds and we
                      value creative thinking. We’re passionate about coming
                      together as one to solve technology challenges at any
                      scale.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-4 align-items-start">
                  <img
                    src="assets/img/TechnologyConsulting/Deploy_img3.svg"
                    alt=""
                  />
                  <div>
                    <h6 className="heading-4 mb-3 fw-bold">
                      Engineering first approach
                    </h6>
                    <p className="sub_para para_color ">
                      Our entire leadership and founding team is comprised of
                      software engineers and technical specialty, allowing us to
                      build robust software applications at scale.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-4 align-items-start">
                  <img
                    src="assets/img/TechnologyConsulting/Deploy_img4.svg"
                    alt=""
                  />
                  <div>
                    <h6 className="heading-4 mb-3 fw-bold">
                      Learning is our top priority
                    </h6>
                    <p className="sub_para para_color ">
                      We’re always looking for fresh new ways to build the very
                      best technology, as we invest in abundance of professional
                      growth and learning resources for all our engineers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </ScrollToTop>
    </>
  );
}
